import { call, put } from "redux-saga/effects";
import { setItems } from "../../slices/item/itemSlice";
import { goBack, push } from "connected-react-router";
import { requestAddSubscription } from "../requests/company";
// import { useSelector } from "react-redux";

export function* handleAddSubscriptionDetail() {
  //   const SubscriptionDetail = useSelector((state) => state.subscriptionDetail);
  //   console.log("SubscriptionDetail", SubscriptionDetail);
  try {
    // yield call(requestAddSubscription(SubscriptionDetail));
    yield put(goBack());
  } catch (error) {
    console.log(error);
  }
}
